import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../language/keys';
import { useGetAssociatedCompanyLinkedin } from '../../hooks/useAccount';
import DialogContent from
  '../AddAccountLinkedinDialog/AccountLinkedinContainer/AccountLinkedinDialogContent';
import { AccountLinkedinContainer } from '../AddAccountLinkedinDialog/AccountLinkedinContainer';

type ChangeCompanyLinkedinDialogProps = {
  onCompanyReady: (company: Company) => void,
  isShowDialog: boolean,
  linkedinUrl: string,
  onLinkedinValueChange: (e:React.ChangeEvent<HTMLInputElement>) => void,
  onCancelClick: () => void,
}

export const ChangeCompanyLinkedinDialog = ({
  onCompanyReady,
  isShowDialog,
  linkedinUrl,
  onLinkedinValueChange,
  onCancelClick,
}:ChangeCompanyLinkedinDialogProps):JSX.Element => {
  const { t: translate } = useTranslation();

  const {
    error,
    isError,
    isLoading,
    mutateAsync,
    reset,
  } = useGetAssociatedCompanyLinkedin((company: Company) => {
    onCompanyReady(company);
  });

  const actionBtnObj = {
    textBtn: translate(STRING_KEYS.CONTINUE),
    color: 'primary',
  } as const;

  const handleLinkedinValueChange = (e:React.ChangeEvent<HTMLInputElement>) => {
    reset();
    onLinkedinValueChange(e);
  };

  return (
    <AccountLinkedinContainer
      titleHeader={ translate(STRING_KEYS.CHANGE_ASSOCIATED_COMPANY) }
      onCloseClick={ onCancelClick }
      onActionClick={ () => {
        mutateAsync(linkedinUrl);
      } }
      isShowDialog={ isShowDialog }
      textBtn={ actionBtnObj.textBtn }
      color={ actionBtnObj.color }
      disabled={ isError || linkedinUrl.trim() === '' || isLoading }
    >
      <DialogContent
        linkedinUrl={ linkedinUrl }
        onLinkedInValueChanged={ handleLinkedinValueChange }
        label={ translate(STRING_KEYS.ACCOUNTS_ASSOCIATED_COMPANY) }
        isLoading={ isLoading }
        error={ isError ? error : null }
      />
    </AccountLinkedinContainer>
  );
};
